// -------------------- APP USER ---------------------

export const updateAppUser = /* GraphQL */ `
  mutation updateAppUser(
    $app_user_id: String!
    $name: String!
    $surname: String!
    $email: String!
    $phone: String
    $language: String
    $user_map_style: String
  ) {
    updateAppUser(
      input: {
        app_user_id: $app_user_id
        name: $name
        surname: $surname
        email: $email
        phone: $phone
        language: $language
        user_map_style: $user_map_style
      }
    ) {
      service_id
    }
  }
`;

// ---------------------- TICKETING SERVICE ---------------------
export const createTicketingRequest = /* GraphQL */ `
  mutation createTicketingRequest($input: TicketingRequestInput!) {
    createTicketingRequest(input: $input) {
      service_id
    }
  }
`;

export const linkLocationToTicketingRequest = /* GraphQL */ `
  mutation linkLocationToTicketingRequest($input: [LinkLocationToTicketingRequestInput]!) {
    linkLocationToTicketingRequest(input: $input) {
      service_id
    }
  }
`;

export const deleteTicketingRequest = /* GraphQL */ `
  mutation deleteTicketingRequest($input: DeleteTicketingRequestInput!) {
    deleteTicketingRequest(input: $input) {
      service_id
    }
  }
`;

export const linkDocumentS3ToTicketingRequest = /* GraphQL */ `
  mutation linkDocumentS3ToTicketingRequest($input: [LinkDocumentS3ToTicketingRequestInput]!) {
    linkDocumentS3ToTicketingRequest(input: $input) {
      service_id
    }
  }
`;

export const deleteDocumentS3 = /* GraphQL */ `
  mutation deleteDocumentS3($document_s3_id: String!) {
    deleteDocumentS3(document_s3_id: $document_s3_id) {
      service_id
    }
  }
`;

export const editTicketingRequest = /* GraphQL */ `
  mutation editTicketingRequest($input: TicketingRequestInput!) {
    editTicketingRequest(input: $input) {
      service_id
    }
  }
`;
// ---------------------- GLOBAL LAYERS ---------------------

export const createGlobalLayer = /* GraphQL */ `
  mutation createGlobalLayer($input: GlobalLayerInput!) {
    createGlobalLayer(input: $input) {
      global_layer_id
      layer_name
      layer_description
      layer_polygon
    }
  }
`;

export const editGlobalLayer = /* GraphQL */ `
  mutation editGlobalLayer($input: GlobalLayerInput!) {
    editGlobalLayer(input: $input) {
      global_layer_id
      layer_name
      layer_description
      layer_polygon
    }
  }
`;

export const deleteCustomerLayer = /* GraphQL */ `
  mutation deleteCustomerLayer($input: DeleteGlobalLayerInput!) {
    deleteCustomerLayer(input: $input) {
      service_id
    }
  }
`;
